const showSharePopUP = function () {
  const columnWrappers = document.querySelectorAll(".stl-column");
  
  columnWrappers.forEach((columnWrapper) => {
    const shareBtns = columnWrapper.querySelectorAll('.share-button');
    const popups = columnWrapper.querySelectorAll(".share-wrapper");
    const videoOverlays = columnWrapper.querySelectorAll(".stl-video-overlay");

    shareBtns.forEach((shareBtn, index) => {
      const popup = popups[index];
      const close = popup.querySelector(".close");
      const field = popup.querySelector(".field");
      const input = field.querySelector("input");
      const copy = field.querySelector("button");

      shareBtn.onclick = () => {
        columnWrappers.forEach((wrapper) => {
          if (wrapper !== columnWrapper) {
            const otherPopups = wrapper.querySelectorAll(".share-wrapper");
            const otherVideoOverlays = wrapper.querySelectorAll(".stl-video-overlay");
            const otherShareBtns = wrapper.querySelectorAll('.share-button');
            otherPopups.forEach((otherPopup) => {
              otherVideoOverlays.forEach(overlay => overlay.classList.remove("show"));
              otherShareBtns.forEach(button => button.classList.remove("active"));
              otherPopup.classList.remove("show");
            });
          }
        });
        videoOverlays.forEach(overlay => overlay.classList.toggle("show"));
        shareBtn.classList.toggle('active');
        popup.classList.toggle("show");
      };

      close.onclick = () => {
        videoOverlays.forEach(overlay => overlay.classList.remove("show"));
        shareBtn.classList.remove('active');
        popup.classList.remove("show");
      };

      copy.onclick = () => {
        input.select();
        if (document.execCommand("copy")) {
          field.classList.add("active");
          copy.innerText = "Copiat";
          setTimeout(() => {
            window.getSelection().removeAllRanges();
            field.classList.remove("active");
            copy.innerText = "Copiază";
          }, 3000);
        }
      };
    });
  });
};

const showShareProdusPopUP = function () {
  const columnWrappers = document.querySelectorAll(".stl-column");
  columnWrappers.forEach((columnWrapper) => {
    const shareBtns = columnWrapper.querySelectorAll('.share-produs-button');

    
    shareBtns.forEach((shareBtn) => {
      shareBtn.onclick = () => {
        const popup = shareBtn.closest(".popup-produs");
        const wrapper = popup.querySelector('.share-produs-wrapper');
        const close = popup.querySelector(".close");
        const field = popup.querySelector(".field");
        const input = field.querySelector("input");
        const copy = field.querySelector("button");
        columnWrapper.querySelectorAll('.share-produs-wrapper').forEach((otherWrapper) => {
          if (otherWrapper !== wrapper) {
            otherWrapper.classList.remove("show");
          }
        });

        wrapper.classList.toggle("show");
        console.log("clicked!");

        close.onclick = () => {
          wrapper.classList.remove("show");
        };

        copy.onclick = () => {
          input.select();
          if (document.execCommand("copy")) {
            field.classList.add("active");
            copy.innerText = "Copied";
            setTimeout(() => {
              window.getSelection().removeAllRanges();
              field.classList.remove("active");
              copy.innerText = "Copy";
            }, 3000);
          }
        };
      };
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  showSharePopUP();
  showShareProdusPopUP();
});
